module.exports = __webpack_public_path__ + "img/W-C47.59ad00dc.jpg";